import { useState } from "react";

export default function CategoryRow() {

  const categories = [
    "All",
    "Movies",
    "Live TV",
    "Kids",
    "Sports",
    "Premium"
  ];

  const [active, setActive] = useState("All");

  return (
    <>
      <div className="cat-wrap">

        {categories.map((cat) => (
          <div
            key={cat}
            className={`cat-item ${active === cat ? "active" : ""}`}
            tabIndex="0"
            onClick={() => setActive(cat)}
          >
            {cat}
          </div>
        ))}

      </div>

      {/* STYLE */}
      <style>{`
        .cat-wrap {
          display: flex;
          gap: 18px;
          padding: 20px;
          overflow-x: auto;
        }

        .cat-wrap::-webkit-scrollbar {
          display: none;
        }

        .cat-item {
          padding: 10px 22px;
          border-radius: 25px;
          background: #111;
          color: #bbb;
          font-size: 14px;
          cursor: pointer;
          outline: none;
          transition: 0.25s;
          white-space: nowrap;
        }

        .cat-item:hover {
          background: #222;
          color: #fff;
        }

        .cat-item:focus {
          border: 2px solid #e50914;
          color: #fff;
          transform: scale(1.1);
        }

        .cat-item.active {
          background: #e50914;
          color: #fff;
          font-weight: bold;
        }
      `}</style>
    </>
  );
}
